import React from 'react';
import { connect } from 'react-redux';
import { Login, NewPasswordRequired, Logout, EmailVerification } from 'react-cognito';
import { Form, Text } from 'react-form';

const KozyLogin = ({username, onSubmit}) => (
    <div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <h1>Login</h1>
        <Form
            onSubmit={({ username, password }) => onSubmit(username, password) }
            render={ ({ submitForm, values, addValue, removeValue }) => (
            <form onSubmit={submitForm}>
                <div>
                    Login : <Text field="username" />
                </div>
                <div>
                    Password: <Text field="password" />
                </div>
                <div>
                    <input type="submit" />
                </div>
            </form>
        )} />
    </div>
)

const KozyNPR = ({onSubmit}) => (
    <div onClick={ () => onSubmit('Test1234!') }>
        <br />
        <br />
        <br />
        <br />
        <br />
        setup pass
    </div>
)

const KozyLogout = ({onClick}) => (
    <div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <div onClick={onClick}>logout</div>
    </div>
)

const KozyEmailVerif = ({...props}) => (
    <div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <div onClick={() => console.log(props)}>Log</div>
    </div>
)

const KozyAuth = ({ state }) => {

    const cases = {
        'LOGGED_OUT': <Login><KozyLogin /></Login>,
        'NEW_PASSWORD_REQUIRED': <NewPasswordRequired><KozyNPR /></NewPasswordRequired>,
        'AUTHENTICATED': <Logout><KozyLogout /></Logout>,
        'LOGGING_IN': <Logout><KozyLogout /></Logout>,
        'LOGGED_IN': <Logout><KozyLogout /></Logout>,
        'EMAIL_VERIFICATION_REQUIRED': <EmailVerification><KozyEmailVerif /></EmailVerification>
    }

    return cases[state];
}

export default connect(
    (state) => {
        console.log(state.cognito);
        return state.cognito
    }
)(KozyAuth);



// WEBPACK FOOTER //
// ./src/components/Login.js